import React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { SearchField } from '@lifeomic/chroma-react/components/SearchField';
import useSurveysList from './useSurveysList';
import { messages } from './messages';

const useStyles = makeStyles(() => ({
  searchField: {
    width: '55%',
  },
}));

const SurveySearchField: React.FC = () => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});
  const { setSearchValue } = useSurveysList();

  return (
    <SearchField
      className={classes.searchField}
      fullWidth
      disableClearOnSearch
      aria-label={formatMessage(messages.search)}
      placeholder={formatMessage(messages.search)}
      onSearch={(value: string) => setSearchValue(value)}
      onClear={() => setSearchValue('*')}
    />
  );
};

export default SurveySearchField;
